import { AdminStatus } from "src/types/adminStatus.ts";
import { Attachment } from "src/types/attachment.ts";
import { Case, CaseSummary } from "src/types/case.ts";
import { ShortElement } from "src/types/element.ts";
import { ScenarioExecutionResultWithCase } from "src/types/scenario.ts";

import { User } from "./user.ts";

export type ShortAlert = {
  id: string;
  decision: AlertValidationDecision | null;
  status: AlertStatus;
  assignee: User | null;
  adminStatus: AdminStatus;
  isAssigned: boolean;
  assigneeFullName: string;
  typeCode: string;
  origin: AlertOrigin;
};

export type AlertWithCase = {
  currentCase: Case;
  creationCase: Case | null;
  validationCase: Case | null;
};

export type AlertWithCaseSummary = {
  currentCase: CaseSummary;
  creationCase: CaseSummary | null;
  validationCase: CaseSummary | null;
};

export type Alert = ShortAlert &
  AlertWithCase & {
    comment: string | null;
    isAlertValidated: boolean;
    isAlertCanceled: boolean;
    requestedDate: Date | null;
    caseImportedDate: Date | null;
    validatorFullName: string | null;
    validationDate: Date | null;
    cancelledDate: Date | null;
    globalScore: number;
    scenarioName: string;
    alertNumber: string;
    creationDate: Date;
    scenarioExecutionResult: ScenarioExecutionResultWithCase | null;
    caseScoringDate: Date | null;
    fraudType: string | null;
    attachments: Attachment[];
    financialLossAmount: number | null;
    preventedFraudAmount: number | null;
  };

export type AlertOrigin = "manual" | "score";

export type AlertStatusTransition =
  | "assign"
  | "confirmAsProven"
  | "dismissAsFalsePositive"
  | "unassign";

export type AlertStatus = "closed" | "notAssigned" | "assigned" | "canceled";

export const AlertValidationDecisionValues = [
  "compliant",
  "fraudPrevented",
  "provenFraudWithNoFinancialLoss",
  "provenFraudWithFinancialLoss",
] as const;

export type AlertValidationDecision = (typeof AlertValidationDecisionValues)[number];

export type AlertSummary = ShortAlert &
  AlertWithCaseSummary & {
    nbrOfIdentifiedCases: number | null;
    scenarioExecutionResult: {
      globalScore: number;
      case: {
        id: string;
        elements: ShortElement[];
      } | null;
      scenarioVersion: {
        name: string;
        scenario: {
          id: string;
          name: string;
        } | null;
      } | null;
    } | null;
  };
